import React from "react";
import { Box } from "@material-ui/core";
import { ExperienceItinerary } from "redmond";
import { ExperienceItineraryDetails } from "halifax";
import clsx from "clsx";

import { ShopComponentSkeleton } from "../../component";
import styles from "./styles.module.scss";

export interface IShopWhatToExpect {
  isSkeleton: boolean;
  itinerary?: ExperienceItinerary;
  mobile?: boolean;
}

export interface IShopWhatToExpectProps extends IShopWhatToExpect {
  mobile?: boolean;
}

const Skeleton = () => (
  <Box className="experiences-shop-skeleton">
    <Box className="section-wrapper">
      <ShopComponentSkeleton name="small" />
      <ShopComponentSkeleton name="large" />
      <ShopComponentSkeleton name="medium" />
    </Box>
    <Box className="section-wrapper">
      <ShopComponentSkeleton name="medium" />
      <ShopComponentSkeleton name="large" />
      <ShopComponentSkeleton name="medium" />
    </Box>
    <Box className="section-wrapper">
      <ShopComponentSkeleton name="large" />
      <ShopComponentSkeleton name="small" />
      <ShopComponentSkeleton name="large" />
    </Box>
  </Box>
);

export const ShopWhatToExpect = (props: IShopWhatToExpectProps) => {
  const { isSkeleton, itinerary, mobile = false } = props;

  if (!itinerary) {
    return null;
  }

  return (
    <Box className={clsx(styles["experiences-shop-what-to-expect-container"])}>
      <ExperienceItineraryDetails itinerary={itinerary} mobile={mobile} />
      {isSkeleton ? <Skeleton /> : null}
    </Box>
  );
};
